var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.extractedGroup.externalUsers,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions,
          selectOptions: _vm.selectOptions
        },
        on: { "on-selected-rows-change": _vm.onSelectionChanged },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "disabled"
                  ? _c("div", { staticClass: "custom-control custom-switch" }, [
                      _c("input", {
                        staticClass: "custom-control-input",
                        attrs: {
                          id: props.row.originalIndex + "_disabled",
                          type: "checkbox"
                        },
                        domProps: { checked: props.row.disabled },
                        on: {
                          change: function($event) {
                            _vm.getRealExternalUserObject(props.row).disabled =
                              $event.target.checked
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "custom-control-label",
                        attrs: { for: props.row.originalIndex + "_disabled" }
                      })
                    ])
                  : props.column.field === "actions"
                  ? _c(
                      "div",
                      { staticClass: "btn-group" },
                      [
                        _vm._t("externalUserButtonsBefore", null, {
                          groupUserExternal: props.row
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary",
                            on: {
                              click: function($event) {
                                return _vm.editUser(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-pen" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-danger",
                            on: {
                              click: function($event) {
                                return _vm.removeUser(props.row)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-trash" })]
                        ),
                        _vm._v(" "),
                        _vm._t("externalUserButtonsAfter", null, {
                          groupUserExternal: props.row
                        })
                      ],
                      2
                    )
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row mt-2" }, [
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { title: _vm.$t("group.editModal.actions.addUser") },
              on: { click: _vm.addUser }
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          ),
          _vm._v(" "),
          !_vm.hideMassSelection
            ? _c(
                "button",
                {
                  staticClass: "btn btn-warning",
                  attrs: {
                    title: _vm.$t("group.editModal.actions.selectUser")
                  },
                  on: { click: _vm.openSelectModal }
                },
                [_c("i", { staticClass: "fa fa-user-plus" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { title: _vm.$t("group.editModal.actions.importUsers") },
              on: { click: _vm.openParseUsersModal }
            },
            [_c("i", { staticClass: "fa fa-upload" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { title: _vm.$t("group.editModal.actions.exportUsers") },
              on: { click: _vm.onExportUsers }
            },
            [_c("i", { staticClass: "fa fa-download" })]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-group ml-auto" },
          [
            _vm._t("selectedExternalUserButtonsBefore", null, {
              groupUserExternals: _vm.selectedRows
            }),
            _vm._v(" "),
            _vm._t("selectedExternalUserButtonsAfter", null, {
              groupUserExternals: _vm.selectedRows
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("ExternalUserParseModal", {
        ref: "importModal",
        on: { parsed: _vm.onUsersParsed }
      }),
      _vm._v(" "),
      _c("ExternalUserSelectModal", {
        ref: "selectModal",
        on: { selected: _vm.onUsersSelected },
        scopedSlots: _vm._u(
          [
            {
              key: "externalUserSelectModalTabs",
              fn: function() {
                return [_vm._t("externalUserSelectModalTabs")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      }),
      _vm._v(" "),
      _c("ExternalUserEditModal", {
        ref: "editModal",
        attrs: {
          availableSalutations: _vm.availableSalutations,
          hideDisabled: _vm.hideDisabled,
          allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers
        },
        on: { save: _vm.onExternalUserSave }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }